import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withTranslations from '../../utils/HighOrderComponent';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import { rowsPerPageOptions } from '../../constants/globals.js';
import { TablePagination } from '@material-ui/core';
import { changePaginationTextToSerbian } from '../../utils';
import {
  findAllMunicipalityPageable,
  findAllMunicipalityFilterPageable,
  updateMunicipality,
  createMunicipality,
} from '../../actions/municipality';
import MunicipalityTable from '../Municipality/MunicipalityTable';

class MunicipalityList extends Component {
  constructor() {
    super();
    this.state = {
      showMunicipality: false,
      municipalityforEdit: null,
    };
  }

  componentDidMount() {
    this.props.findAllMunicipalityPageable(0, this.props.pageSize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'municipality',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllMunicipalityFilterPageable(
        0,
        nextProps.pageSize,
        postData
      );
      nextProps.setResetData(false);
    }
  }

  handleFindAllTrigger = (pageNumber, pageSize) => {
    this.props.findAllMunicipalityPageable(pageNumber, pageSize);
  };

  handlePageChange = (event, value) => {
    const {
      setActivePage,
      postData,
      pageSize,
      findAllMunicipalityPageable,
      findAllMunicipalityFilterPageable,
    } = this.props || {};
    setActivePage(value);
    postData
      ? findAllMunicipalityFilterPageable(value, pageSize, postData)
      : findAllMunicipalityPageable(value, pageSize);
  };

  handleClose = () => {
    this.setState({ showMunicipality: false, municipalityforEdit: null });
  };

  handleOpen = (municipalityforEdit) => {
    this.setState({
      showMunicipality: true,
      municipalityforEdit: municipalityforEdit,
    });
  };

  handleChangeRowsPerPage = (event, value) => {
    const {
      setPageSize,
      setActivePage,
      postData,
      findAllMunicipalityFilterPageable,
    } = this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllMunicipalityFilterPageable(0, event.target.value, postData)
      : this.handleFindAllTrigger(0, event.target.value);
  };

  render() {
    const {
        t,
        municipality,
        municipalityList,
        updateMunicipality,
        createMunicipality,
        placeList,
        activePage,
        pageSize,
      } = this.props || {},
      { totalElements, loading } = municipality || {};

    if (loading) {
      return <LoadingIndicator />;
    }

    return (
      <Fragment>
        <MunicipalityTable
          municipalityList={municipalityList}
          updateMunicipality={updateMunicipality}
          createMunicipality={createMunicipality}
          placeList={placeList}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange.bind(this)}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage.bind(this)}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  municipality: state.municipality,
  municipalityList: state.municipality.municipalityList || [],
  loggedUser: state.loggedUser?.loggedUser,
  placeList: state.place?.placeList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllMunicipalityPageable: (pageNumber, pageSize) => {
      dispatch(findAllMunicipalityPageable(pageNumber, pageSize));
    },
    updateMunicipality: (municipality, callback, messages) => {
      dispatch(updateMunicipality(municipality, callback, messages));
    },
    createMunicipality: (municipality, callback, messages) => {
      dispatch(createMunicipality(municipality, callback, messages));
    },
    findAllMunicipalityFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllMunicipalityFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(MunicipalityList, 'MunicipalityList'));
